/* ============================================================
   Alpha Golf — Iron Shaft Finder Quiz
   Scoring V2 — exact port from Grips4Less iron-shaft-quiz-v5.js

   IMPORTANT:
   Keep your window.IRON_SHAFT_SPECS = { ... } spec sheet loaded ABOVE this script.
   This file is the full quiz logic that should run after the spec sheet.
   ============================================================ */

var SHOP = 'alpha-golf.myshopify.com';
var API  = 'https://' + SHOP + '/api/2025-01/graphql.json';
var TOTAL_Q = 12;
var ans = {};

/* ─────────────────────────────────────────────
   POSTHOG QUIZ TRACKING (stubbed — wire up if PostHog is installed on Alpha Golf)
─────────────────────────────────────────────── */
function getIronQuizSessionId() {
  try {
    var key = 'iron_quiz_session_id';
    var existing = localStorage.getItem(key);
    if (existing) return existing;
    var id = 'iron_' + Date.now() + '_' + Math.random().toString(36).slice(2);
    localStorage.setItem(key, id);
    return id;
  } catch(e) {
    return 'iron_ns_' + Date.now();
  }
}

/*
  Answer key (identical to Grips4Less):
  ans[0]  = speed:     slow / mod / modfast / fast / vfast
  ans[1]  = tempo:     smooth / mod / aggressive
  ans[2]  = flight:    balloon / midhigh / mid / low
  ans[3]  = shape:     draw / straight / fade / varies
  ans[4]  = striking:  elite / solid / average / inconsistent
  ans[5]  = pain:      pain / no
  ans[6]  = goal:      control / distance / feel / height / consistency
  ans[7]  = current:   stock / lightgraphite / composite / lightsteel / midsteel / toursteel
  ans[8]  = handicap:  scratch / low / mid / high / casual
  ans[9]  = tip:       355 / 370 / unsure
  ans[10] = budget:    low / mid / high
  ans[11] = senior:    yes / no
*/

var BUDGET_CAP = { low: 45, mid: 90, high: 9999 };

var COLLECTION = window.COLLECTION = {
  tourSteel:      'iron-shafts',
  heavyControl:   'iron-shafts',
  midControl:     'iron-shafts',
  midDistance:    'iron-shafts',
  lightSteel:     'iron-shafts',
  compositeMid:   'graphite-iron-golf-shafts',
  compositeLight: 'graphite-iron-golf-shafts',
  graphiteHigh:   'graphite-iron-golf-shafts',
  graphiteMid:    'graphite-iron-golf-shafts'
};

/* Alpha Golf collection handles */
var ALPHA_COLLECTION = {
  'iron-shafts':              'iron-shafts',
  'graphite-iron-golf-shafts': 'iron-shafts'  /* Alpha Golf uses one iron-shafts collection */
};

var ALWAYS_EXCLUDE_TAGS = [
  'wedge', 'wedge shaft', 'wedge-shafts', 'dart v wedge', 'style_wedge shaft',
  'driver-wood-shafts', 'style_wood shaft', 'style_fairway wood',
  'style_hybrid shaft', 'style_hybrid', 'hybrid-shafts', 'hybrid shaft',
  'style_putter shaft', 'putter-shafts', 'putter shaft',
  'bundle', 'shaft bundle', 'bundles set', 'bundle set',
  'assembled', 'assembled-golf-shaft', 'assembled-iron-club',
  'junior', 'junior shaft'
];

var TIP_EXCLUDE = {
  '355': ['tip size_0.370" tip', '.370 tip', '0.370" tip', 'parallel tip', 'golf-shafts-370-tip-size'],
  '370': ['tip size_0.355" tip', 'golf-shafts-355-tip-size', 'taper tip', 'tapered tip', 'temp-tag-355']
};

var MATERIAL_EXCLUDE = {
  steel: ['graphite shaft', 'graphite', 'graphite design'],
  graphite: ['steel shaft']
};

/* ─────────────────────────────────────────────
   PROFILE TOKENS — SPEC-BASED TARGETS
─────────────────────────────────────────────── */
var PROFILE_TOKENS = window.PROFILE_TOKENS = {
  tourSteel:      { launch:['low','low-mid','mid-low'], spin:['low','mid-low'],            launchExclude:['mid-high','high'],        weightMin:115, weightMax:145, torqueMin:1.3, torqueMax:2.3 },
  heavyControl:   { launch:['low','low-mid','mid-low','mid'], spin:['low','mid-low','mid'], launchExclude:['high'],                  weightMin:110, weightMax:130, torqueMin:1.5, torqueMax:2.5 },
  midControl:     { launch:['mid','mid-low'],            spin:['mid','mid-low'],            launchExclude:['high'],                   weightMin:95,  weightMax:120, torqueMin:1.6, torqueMax:2.8 },
  midDistance:    { launch:['mid','mid-high','high'],    spin:['mid','mid-high','high'],    launchExclude:['low'],                    weightMin:85,  weightMax:115, torqueMin:1.8, torqueMax:3.5 },
  lightSteel:     { launch:['mid','mid-high','high'],    spin:['mid','mid-high','high'],    launchExclude:['low','mid-low'],           weightMin:60,  weightMax:100, torqueMin:1.9, torqueMax:4.0 },
  compositeMid:   { launch:['mid-low','mid','mid-high'], spin:['mid-low','mid','mid-high'], launchExclude:['high'],                   weightMin:70,  weightMax:115, torqueMin:1.8, torqueMax:3.8 },
  compositeLight: { launch:['mid','mid-high','high'],    spin:['mid','mid-high','high'],    launchExclude:['low'],                    weightMin:50,  weightMax:95,  torqueMin:2.3, torqueMax:5.0 },
  graphiteHigh:   { launch:['mid-high','high'],          spin:['mid','mid-high','high'],    launchExclude:['low','mid-low'],           weightMin:40,  weightMax:90,  torqueMin:3.0, torqueMax:6.0 },
  graphiteMid:    { launch:['mid','mid-high','high'],    spin:['mid','mid-high','high'],    launchExclude:['low'],                    weightMin:55,  weightMax:100, torqueMin:2.3, torqueMax:4.8 }
};

var SPEED_MAP_DRIVER = window.SPEED_MAP_DRIVER = {
  slow:    { min: 68,  max: 82  },
  mod:     { min: 82,  max: 93  },
  modfast: { min: 93,  max: 103 },
  fast:    { min: 103, max: 112 },
  vfast:   { min: 112, max: 130 }
};

/* ─────────────────────────────────────────────
   SHAFT FAMILY DETECTION — identical to G4L
─────────────────────────────────────────────── */
function getShaftFamilyFromHandle(handle, title) {
  var x = ((handle || '') + ' ' + (title || '')).toLowerCase();

  if (x.indexOf('mmt') !== -1) return 'mmt';
  if (x.indexOf('recoil-dart') !== -1 || x.indexOf('recoil dart') !== -1) return 'recoil-dart';
  if (x.indexOf('recoil-660') !== -1 || x.indexOf('recoil 660') !== -1 || x.indexOf('recoil-680') !== -1 || x.indexOf('recoil 680') !== -1) return 'recoil-660';
  if (x.indexOf('recoil') !== -1) return 'recoil';
  if (x.indexOf('vista-pro') !== -1 || x.indexOf('vista pro') !== -1) return 'vista-pro';
  if (x.indexOf('cypher') !== -1) return 'cypher';
  if (x.indexOf('c6') !== -1) return 'c6';

  if (x.indexOf('kbs-max-80') !== -1 || x.indexOf('kbs max 80') !== -1) return 'kbs-max';
  if (x.indexOf('kbs-max-65') !== -1 || x.indexOf('kbs max 65') !== -1) return 'kbs-max';
  if (x.indexOf('kbs-max-55') !== -1 || x.indexOf('kbs max 55') !== -1) return 'kbs-max';
  if (x.indexOf('kbs-max-graphite') !== -1 || x.indexOf('kbs max graphite') !== -1) return 'kbs-max';
  if (x.indexOf('kbs max') !== -1 || x.indexOf('kbs-max') !== -1) return 'kbs-max';

  if (x.indexOf('kbs-tour-lite') !== -1 || x.indexOf('kbs tour lite') !== -1) return 'kbs-tour-lite';
  if (x.indexOf('kbs-c-taper-lite') !== -1 || x.indexOf('c-taper-lite') !== -1 || x.indexOf('c taper lite') !== -1) return 'kbs-c-taper-lite';
  if (x.indexOf('kbs-c-taper') !== -1 || x.indexOf('c-taper') !== -1 || x.indexOf('c taper') !== -1) return 'kbs-c-taper';
  if (x.indexOf('kbs-s-taper') !== -1 || x.indexOf('$-taper') !== -1 || x.indexOf('s-taper') !== -1) return 'kbs-s-taper';
  if (x.indexOf('kbs-tour') !== -1 || x.indexOf('kbs tour') !== -1) return 'kbs-tour';

  if (x.indexOf('project-x-ls') !== -1 || x.indexOf('project x ls') !== -1) return 'project-x-ls';
  if (x.indexOf('project-x-lz') !== -1 || x.indexOf('project x lz') !== -1) return 'project-x-lz';
  if (x.indexOf('project-x-rifle') !== -1 || x.indexOf('project x rifle') !== -1) return 'project-x-rifle';
  if (x.indexOf('project-x-catalyst') !== -1 || x.indexOf('project x catalyst') !== -1) return 'project-x-catalyst';
  if (x.indexOf('project-x') !== -1 || x.indexOf('project x') !== -1) return 'project-x';

  if (x.indexOf('dynamic-gold-x7') !== -1 || x.indexOf('dynamic gold x7') !== -1) return 'dynamic-gold-x7';
  if (x.indexOf('dynamic-gold-tour-issue') !== -1 || x.indexOf('dynamic gold tour issue') !== -1) return 'dynamic-gold-tour-issue';
  if (x.indexOf('dynamic-gold-120') !== -1 || x.indexOf('dynamic gold 120') !== -1) return 'dynamic-gold-120';
  if (x.indexOf('dynamic-gold') !== -1 || x.indexOf('dynamic gold') !== -1) return 'dynamic-gold';

  if (x.indexOf('amt-white') !== -1 || x.indexOf('amt white') !== -1) return 'amt-white';
  if (x.indexOf('amt-black') !== -1 || x.indexOf('amt black') !== -1) return 'amt-black';
  if (x.indexOf('amt-red') !== -1 || x.indexOf('amt red') !== -1) return 'amt-red';
  if (x.indexOf('amt') !== -1) return 'amt';

  if (x.indexOf('steelfiber') !== -1 || x.indexOf('aerotech') !== -1) return 'steelfiber';
  if (x.indexOf('fujikura-mci') !== -1 || x.indexOf('fujikura mci') !== -1 || x.indexOf('mci') !== -1) return 'fujikura-mci';
  if (x.indexOf('fujikura-pro') !== -1 || x.indexOf('fujikura pro') !== -1) return 'fujikura-pro';
  if (x.indexOf('fujikura-axiom') !== -1 || x.indexOf('fujikura axiom') !== -1) return 'fujikura-axiom';
  if (x.indexOf('mitsubishi-ot') !== -1 || x.indexOf('mitsubishi ot') !== -1) return 'mitsubishi-ot';

  if (x.indexOf('modus3-tour120') !== -1 || x.indexOf('modus3 tour120') !== -1 || x.indexOf('modus3 tour 120') !== -1) return 'modus3-120';
  if (x.indexOf('modus3') !== -1) return 'modus3';
  if (x.indexOf('950gh') !== -1) return 'nippon-950';
  if (x.indexOf('1150gh') !== -1) return 'nippon-1150';
  if (x.indexOf('850gh') !== -1) return 'nippon-850';
  if (x.indexOf('elevate') !== -1) return 'elevate';
  if (x.indexOf('xp-95') !== -1 || x.indexOf('xp 95') !== -1 || x.indexOf('xp95') !== -1) return 'xp-95';
  if (x.indexOf('zelos') !== -1) return 'zelos';
  if (x.indexOf('alpha-tour-lite') !== -1 || x.indexOf('alpha tour lite') !== -1) return 'alpha-tour-lite';
  if (x.indexOf('platinum-iron') !== -1 || x.indexOf('platinum iron') !== -1) return 'alpha-platinum';

  return x.split(/\s+/).slice(0, 2).join('-');
}

/* ─────────────────────────────────────────────
   PROFILE-SPECIFIC FAMILY BONUSES — identical to G4L
─────────────────────────────────────────────── */
function getProfileFamilyBonus(handle, title, profileKey, spec) {
  var family = getShaftFamilyFromHandle(handle, title);
  var bonus = 0;

  var senior   = ans[11] === 'yes';
  var pain     = ans[5] === 'pain';
  var goal     = ans[6];
  var flight   = ans[2];
  var handicap = ans[8];
  var beginner = handicap === 'high' || handicap === 'casual';

  if (senior && pain) {
    if (family === 'recoil' || family === 'recoil-660' || family === 'recoil-dart') bonus += 22;
    if (family === 'cypher') bonus += 14;
    if (family === 'fujikura-mci') bonus += 16;
    if (family === 'mitsubishi-ot') bonus += 14;
    if (family === 'mmt') bonus += 8;
    if (family === 'vista-pro') bonus += 10;
    if (family === 'steelfiber') bonus += 10;
    if (family === 'kbs-max') bonus += 6;
  }

  if (beginner && !pain) {
    if (family === 'cypher') bonus += 22;
    if (family === 'vista-pro') bonus += 20;
    if (family === 'c6') bonus += 18;
    if (family === 'kbs-max') bonus += 20;
    if (family === 'recoil-dart') bonus += 14;
    if (family === 'recoil-660') bonus += 10;
    if (family === 'alpha-tour-lite') bonus += 16;
    if (family === 'alpha-platinum') bonus += 14;
    if (family === 'mmt') bonus -= 8;
    if (family === 'fujikura-mci') bonus -= 6;
    if (family === 'mitsubishi-ot') bonus -= 6;
  }

  if (senior && !pain && goal === 'consistency') {
    if (family === 'kbs-max') bonus += 26;
    if (family === 'vista-pro') bonus += 18;
    if (family === 'recoil-660') bonus += 18;
    if (family === 'cypher') bonus += 12;
    if (family === 'kbs-tour-lite') bonus += 14;
    if (family === 'xp-95') bonus += 10;
    if (family === 'elevate') bonus += 10;
    if (family === 'zelos') bonus += 8;
    if (family === 'alpha-tour-lite') bonus += 14;
  }

  if ((profileKey === 'tourSteel' || profileKey === 'heavyControl' || profileKey === 'midControl') && flight === 'balloon') {
    if (family === 'kbs-c-taper') bonus += 24;
    if (family === 'project-x-ls') bonus += 24;
    if (family === 'project-x-rifle') bonus += 20;
    if (family === 'project-x') bonus += 18;
    if (family === 'dynamic-gold-tour-issue') bonus += 18;
    if (family === 'dynamic-gold-x7') bonus += 20;
    if (family === 'dynamic-gold-120') bonus += 14;
    if (family === 'kbs-s-taper') bonus += 8;
    if (spec.launch === 'low') bonus += 12;
    if (spec.launch === 'mid-low' || spec.launch === 'low-mid') bonus += 8;
    if (spec.spin === 'low') bonus += 12;
    if (spec.spin === 'mid-low') bonus += 8;
  }

  if (profileKey === 'tourSteel' && (ans[0] === 'vfast' || ans[0] === 'fast') &&
      (ans[8] === 'scratch' || ans[8] === 'low') && ans[6] === 'control') {
    if (family === 'kbs-c-taper') bonus += 24;
    if (family === 'kbs-s-taper') bonus += 16;
    if (family === 'dynamic-gold-120') bonus += 16;
    if (family === 'dynamic-gold-tour-issue') bonus += 18;
    if (family === 'dynamic-gold-x7') bonus += 18;
    if (family === 'project-x-ls') bonus += 20;
    if (family === 'project-x-rifle') bonus += 18;
    if (family === 'project-x') bonus += 14;
    if (family === 'amt-white') bonus += 10;

    if (family === 'nippon-950' || family === 'nippon-1150' || family === 'nippon-850') bonus -= 34;
    if (family === 'zelos' || family === 'xp-95' || family === 'elevate') bonus -= 24;
    if (spec.weightMax < 110) bonus -= 22;
    if (spec.launch === 'mid-high' || spec.launch === 'high') bonus -= 16;
    if (spec.spin === 'mid-high' || spec.spin === 'high') bonus -= 14;
  }

  if (family === 'mmt' && (profileKey === 'compositeMid' || profileKey === 'compositeLight') &&
      (goal === 'feel' || pain)) {
    bonus += 14;
  }

  if (goal === 'distance' && ans[0] === 'modfast' && ans[1] === 'smooth' &&
      (profileKey === 'compositeLight' || profileKey === 'graphiteMid')) {
    if (family === 'steelfiber') bonus += 18;
    if (family === 'project-x-catalyst') bonus += 16;
    if (family === 'mmt') bonus += 8;
    if (family === 'mitsubishi-ot') bonus += 8;
    if (family === 'recoil-dart') bonus += 8;
    if (family === 'fujikura-pro') bonus += 8;
  }

  if (profileKey === 'compositeMid' || profileKey === 'compositeLight') {
    if (family === 'steelfiber') bonus += 14;
    if (family === 'fujikura-mci') bonus += 14;
    if (family === 'fujikura-pro') bonus += 10;
    if (family === 'recoil-dart') bonus += 10;
    if (family === 'mitsubishi-ot') bonus += 10;
  }

  if (goal === 'distance' && (profileKey === 'compositeLight' || profileKey === 'graphiteHigh' || profileKey === 'graphiteMid')) {
    if (family === 'recoil-dart') bonus += 16;
    if (family === 'steelfiber') bonus += 14;
    if (family === 'fujikura-mci') bonus += 12;
    if (family === 'fujikura-pro') bonus += 12;
    if (family === 'kbs-max') bonus += 14;
    if (family === 'vista-pro') bonus += 10;
    if (family === 'cypher') bonus += 10;
    if (family === 'alpha-tour-lite') bonus += 12;
    if (family === 'alpha-platinum') bonus += 10;
  }

  if (family === 'kbs-tour-lite') {
    if (profileKey === 'midDistance') bonus += 16;
    if (profileKey === 'lightSteel') bonus += 16;
    if (profileKey === 'midControl') bonus += 10;
  }

  return bonus;
}

/* ─────────────────────────────────────────────
   SPEC-BASED SCORER — identical to G4L
─────────────────────────────────────────────── */
window.scoreFromSpec = function scoreFromSpec(handle, profileKey, productTitle) {
  var SPECS = window.IRON_SHAFT_SPECS;
  if (!SPECS) return null;

  var s = SPECS[handle];
  if (!s) return null;

  var p = PROFILE_TOKENS[profileKey];
  if (!p) return null;

  if (p.launchExclude.indexOf(s.launch) !== -1) return -999;

  var score = 0;

  if (p.launch.indexOf(s.launch) !== -1) score += 34;
  else score -= 6;

  if (p.spin.indexOf(s.spin) !== -1) score += 22;
  else score -= 4;

  var flight = ans[2];
  var goal = ans[6];

  if (flight === 'balloon') {
    if (s.launch === 'low') score += 14;
    if (s.launch === 'mid-low' || s.launch === 'low-mid') score += 10;
    if (s.spin === 'low') score += 14;
    if (s.spin === 'mid-low') score += 10;
    if (s.launch === 'high' || s.launch === 'mid-high') score -= 18;
    if (s.spin === 'high' || s.spin === 'mid-high') score -= 14;
  }

  if (flight === 'low' || goal === 'height') {
    if (s.launch === 'high') score += 14;
    if (s.launch === 'mid-high') score += 10;
    if (s.spin === 'high') score += 8;
    if (s.spin === 'mid-high') score += 6;
    if (s.launch === 'low') score -= 16;
  }

  if (s.weightMax >= p.weightMin && s.weightMin <= p.weightMax) score += 20;
  else if (s.weightMin > p.weightMax + 15 || s.weightMax < p.weightMin - 15) score -= 25;

  if (s.torque >= p.torqueMin && s.torque <= p.torqueMax) score += 10;
  else if (s.torque < p.torqueMin - 0.5 || s.torque > p.torqueMax + 0.5) score -= 10;

  var playerSpeed = SPEED_MAP_DRIVER[ans[0]];
  if (playerSpeed && s.speedMin && s.speedMax) {
    if (playerSpeed.max >= s.speedMin && playerSpeed.min <= s.speedMax) score += 12;
    else score -= 12;
  }

  var family = getShaftFamilyFromHandle(handle, productTitle || '');

  if (family === 'mmt') {
    if ((profileKey === 'compositeMid' || profileKey === 'compositeLight') && (goal === 'feel' || ans[5] === 'pain')) {
      score = Math.round(score * 0.95);
    } else {
      score = Math.round(score * 0.85);
    }
  }

  score += getProfileFamilyBonus(handle, productTitle || '', profileKey, s);

  if (s.confidence === 'HIGH') score += 3;
  else if (s.confidence === 'MED') score += 1;
  else if (s.confidence === 'LOW') score -= 4;

  if (playerSpeed && s.speedMin && s.speedMax) {
    var playerMid = (playerSpeed.min + playerSpeed.max) / 2;
    var shaftMid  = (s.speedMin + s.speedMax) / 2;
    var halfRange = (s.speedMax - s.speedMin) / 2;
    if (halfRange > 0) {
      var centered = Math.max(0, 1 - Math.abs(playerMid - shaftMid) / halfRange);
      score += Math.round(centered * 3 * 10) / 10;
    }
  }

  var overlapMin = Math.max(s.weightMin, p.weightMin);
  var overlapMax = Math.min(s.weightMax, p.weightMax);
  if (overlapMax > overlapMin) {
    var profileRange = p.weightMax - p.weightMin;
    if (profileRange > 0) {
      var precision = (overlapMax - overlapMin) / profileRange;
      score += Math.round(Math.min(precision, 1) * 3 * 10) / 10;
    }
  }

  return score;
};

/* ─────────────────────────────────────────────
   HARD FILTERS — identical to G4L
─────────────────────────────────────────────── */
function specHardFilter(handle, tipAnswer, materialWanted) {
  var SPECS = window.IRON_SHAFT_SPECS;
  if (!SPECS) return null;

  var s = SPECS[handle];
  if (!s) return null;

  var h = (handle || '').toLowerCase();
  var HANDLE_EXCLUDES = ['lady', 'ladies', '-jr-', 'junior', 'bassara', 'hybrid', 'proforce-lady', 'wedge', 'putter', 'adapter-tip-grip', 'assembled'];

  for (var i = 0; i < HANDLE_EXCLUDES.length; i++) {
    if (h.indexOf(HANDLE_EXCLUDES[i]) !== -1) return 'handle exclude: ' + HANDLE_EXCLUDES[i];
  }

  if (tipAnswer && tipAnswer !== 'unsure' && s.tip !== 'unsure' && s.tip !== tipAnswer) return 'tip mismatch';

  if (materialWanted === 'steel' && s.material !== 'steel') return 'material: ' + s.material;
  if (materialWanted === 'graphite' && s.material === 'steel') return 'material: steel';

  return null;
}

function scoreDescription(desc, profileKey) {
  if (!desc) return 4;
  var d = desc.toLowerCase();
  var p = PROFILE_TOKENS[profileKey];
  if (!p) return 0;

  var score = 0;

  function containsAny(arr) {
    return arr.some(function(term) { return d.indexOf(term) !== -1; });
  }

  for (var i = 0; i < p.launchExclude.length; i++) {
    if (d.indexOf(p.launchExclude[i] + ' launch') !== -1) return -999;
  }

  if (containsAny(p.launch.map(function(x){ return x + ' launch'; }))) score += 24;
  if (containsAny(p.spin.map(function(x){ return x + ' spin'; }))) score += 16;

  if (ans[2] === 'balloon') {
    if (d.indexOf('low launch') !== -1 || d.indexOf('mid-low launch') !== -1) score += 12;
    if (d.indexOf('low spin') !== -1 || d.indexOf('mid-low spin') !== -1) score += 12;
    if (d.indexOf('high launch') !== -1 || d.indexOf('high spin') !== -1) score -= 14;
  }

  if (ans[2] === 'low' || ans[6] === 'height') {
    if (d.indexOf('high launch') !== -1 || d.indexOf('mid-high launch') !== -1) score += 14;
    if (d.indexOf('low launch') !== -1) score -= 12;
  }

  var bareGramMatches = d.match(/\b(\d{2,3})g\b/gi);
  if (bareGramMatches) {
    var match = bareGramMatches.some(function(m) {
      var v = parseInt(m, 10);
      return v >= p.weightMin && v <= p.weightMax;
    });
    if (match) score += 14;
  }

  return score;
}

function getTagBonus(tags, profileKey) {
  var tl = (tags || []).map(function(t){ return t.toLowerCase(); });
  var bonus = 0;

  function hasAnyTag(arr) {
    return arr.some(function(t){ return tl.indexOf(t.toLowerCase()) !== -1; });
  }

  var senior = ans[11] === 'yes';
  var pain = ans[5] === 'pain';
  var goal = ans[6];

  if (senior || ans[0] === 'slow') {
    if (hasAnyTag(['senior shaft'])) bonus += 12;
    if (hasAnyTag(['ultra lightweight'])) bonus += 8;
    if (hasAnyTag(['kbs max', 'kbs-max', 'kbs max graphite'])) bonus += 12;
    if (hasAnyTag(['cypher', 'vista pro', 'recoil 660'])) bonus += 10;
  }

  if (pain) {
    if (hasAnyTag(['recoil', 'ust recoil', 'recoil dart'])) bonus += 12;
    if (hasAnyTag(['mci', 'fujikura mci'])) bonus += 10;
    if (hasAnyTag(['steelfiber', 'aerotech'])) bonus += 10;
    if (hasAnyTag(['mitsubishi ot'])) bonus += 8;
    if (hasAnyTag(['mmt', 'mitsubishi mmt'])) bonus += 5;
  }

  if (goal === 'distance') {
    if (hasAnyTag(['recoil dart', 'steelfiber', 'fujikura pro', 'mci', 'kbs max'])) bonus += 8;
  }

  if (profileKey === 'tourSteel' || profileKey === 'heavyControl') {
    if (hasAnyTag(['project x', 'project-x', 'c-taper', 'dynamic gold x100', 'dynamic gold x7'])) bonus += 10;
  }

  if (profileKey === 'midDistance' || profileKey === 'lightSteel' || profileKey === 'midControl') {
    if (hasAnyTag(['kbs tour lite', 'kbs-tour-lite'])) bonus += 10;
  }

  return bonus;
}

function scoreProduct(product, profileKey, materialMode) {
  var title  = (product.title || '').toLowerCase();
  var tags   = product.tags || [];
  var tl     = tags.map(function(t){ return t.toLowerCase(); });
  var desc   = (product.description || '').toLowerCase();
  var price  = parseFloat(product.priceRange.minVariantPrice.amount);
  var tip    = ans[9];
  var budget = ans[10];
  var mat    = materialMode || ((COLLECTION[profileKey] === 'iron-shafts') ? 'steel' : 'graphite');

  for (var i = 0; i < ALWAYS_EXCLUDE_TAGS.length; i++) {
    if (tl.indexOf(ALWAYS_EXCLUDE_TAGS[i]) !== -1) return -999;
  }

  if (title.indexOf('wedge') !== -1 && title.indexOf('iron') === -1) return -999;
  if (title.indexOf('bundle') !== -1 || title.indexOf('assembled') !== -1) return -999;
  if (title.indexOf('hybrid') !== -1 || title.indexOf('putter') !== -1) return -999;
  if (title.indexOf('junior') !== -1 || title.indexOf(' jr ') !== -1 || title.indexOf(' jr.') !== -1 || title.indexOf('-jr-') !== -1) return -999;
  if (title.indexOf('lady') !== -1 || title.indexOf('ladies') !== -1 || title.indexOf('lady lite') !== -1) return -999;
  if (title.indexOf('bassara') !== -1 || title.indexOf('grand bassara') !== -1) return -999;

  if (tip && tip !== 'unsure' && TIP_EXCLUDE[tip]) {
    for (var j = 0; j < TIP_EXCLUDE[tip].length; j++) {
      if (tl.indexOf(TIP_EXCLUDE[tip][j]) !== -1) return -999;
    }
  }

  if (mat !== 'mixed_light' && mat !== 'any' && MATERIAL_EXCLUDE[mat]) {
    for (var k = 0; k < MATERIAL_EXCLUDE[mat].length; k++) {
      if (tl.indexOf(MATERIAL_EXCLUDE[mat][k]) !== -1) return -999;
    }
  }

  var sfReason = specHardFilter(product.handle, tip, mat);
  if (sfReason) return -999;

  var specScore = scoreFromSpec(product.handle, profileKey, product.title);
  var score;

  if (specScore === -999) return -999;
  if (specScore !== null) {
    score = specScore;
  } else {
    var descScore = scoreDescription(desc, profileKey);
    if (descScore === -999) return -999;
    score = descScore + getTagBonus(tags, profileKey);
  }

  if (budget && BUDGET_CAP[budget] && !isNaN(price)) {
    var cap = BUDGET_CAP[budget];
    if (budget === 'low' && price > cap) return -999;
    if (budget === 'mid') {
      if (price > cap * 1.25) return -999;
      if (price > cap) score -= 12;
    }
  }

  return score;
}

/* ─────────────────────────────────────────────
   GRAPHQL + FETCH — Alpha Golf endpoint
─────────────────────────────────────────────── */
var GQL = 'query($h:String!){collection(handle:$h){products(first:250,sortKey:COLLECTION_DEFAULT){edges{node{title handle description tags priceRange{minVariantPrice{amount}}featuredImage{url altText}}}}}}';

function fetchCollectionProducts(collectionHandle) {
  /* Alpha Golf uses 'iron-shafts' for both steel and graphite iron shafts */
  var alphaHandle = ALPHA_COLLECTION[collectionHandle] || collectionHandle;

  return fetch(API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': '' },
    body: JSON.stringify({ query: GQL, variables: { h: alphaHandle } })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (!data || !data.data || !data.data.collection) return [];
    return data.data.collection.products.edges.map(function(e) { return e.node; });
  });
}

function fetchAndScore(profileObj, collectionHandleOrHandles, callback) {
  var profileKey = (typeof profileObj === 'string') ? profileObj : profileObj.r;
  var materialMode = (typeof profileObj === 'string') ? null : (profileObj.materialMode || profileObj.material || null);
  window._currentProfileKey = profileKey;

  /* Alpha Golf: always fetch from iron-shafts — deduplicate */
  var handles = ['iron-shafts'];

  Promise.all(handles.map(fetchCollectionProducts))
    .then(function(results) {
      var productMap = {};
      var products = [];

      results.forEach(function(list) {
        list.forEach(function(p) {
          if (!productMap[p.handle]) {
            productMap[p.handle] = true;
            products.push(p);
          }
        });
      });

      var scoredRaw = products
        .map(function(p) {
          return { p: p, s: scoreProduct(p, profileKey, materialMode), family: getShaftFamilyFromHandle(p.handle, p.title) };
        })
        .filter(function(x) { return x.s > 0; })
        .sort(function(a, b) { return b.s - a.s; });

      if (scoredRaw.length === 0) {
        callback(null, products.slice(0, 20));
        return;
      }

      var familyCount = {};
      var mmtCount = 0;
      var amtCount = 0;
      var modusCount = 0;
      var diversified = [];

      for (var i = 0; i < scoredRaw.length && diversified.length < 20; i++) {
        var item = scoredRaw[i];
        var family = item.family;

        if (family === 'mmt' && mmtCount >= 1) continue;
        if ((family === 'amt' || family === 'amt-white' || family === 'amt-black' || family === 'amt-red') && amtCount >= 1) continue;
        if ((family === 'modus3' || family === 'modus3-120') && modusCount >= 1) continue;

        familyCount[family] = familyCount[family] || 0;
        var maxFamilyAllowed = 2;

        if (ans[6] === 'distance' && ans[0] === 'modfast' && ans[1] === 'smooth' &&
            (profileKey === 'compositeLight' || profileKey === 'graphiteMid') &&
            (family === 'recoil-dart' || family === 'fujikura-pro')) {
          maxFamilyAllowed = 1;
        }

        if ((profileKey === 'compositeMid' || profileKey === 'compositeLight') &&
            (ans[6] === 'feel' || ans[5] === 'pain') &&
            family === 'fujikura-pro') {
          maxFamilyAllowed = 1;
        }

        if (familyCount[family] >= maxFamilyAllowed) continue;

        diversified.push(item.p);
        familyCount[family]++;

        if (family === 'mmt') mmtCount++;
        if (family === 'amt' || family === 'amt-white' || family === 'amt-black' || family === 'amt-red') amtCount++;
        if (family === 'modus3' || family === 'modus3-120') modusCount++;
      }

      callback(null, diversified);
    })
    .catch(function(err) { callback(err, null); });
}

/* ─────────────────────────────────────────────
   FINISH GROUPING + RENDERING
─────────────────────────────────────────────── */
var FINISH_SUFFIXES = [
  ' - black matte', ' - black pvd', ' - blackout finish', ' - new black finish',
  ' - gunmetal', ' - gunmetal finish', ' - black onyx', ' - black onyx finish',
  ' - chrome finish', ' - chrome', ' - blackout',
  '- black matte', '- black pvd', '- blackout finish', '- new black finish',
  '- gunmetal finish', '- gunmetal', '- black onyx finish', '- black onyx',
  '- chrome finish', '- chrome', '- blackout',
  ' black matte', ' black pvd', ' blackout finish', ' new black finish',
  ' gunmetal finish', ' gunmetal', ' black onyx', ' chrome finish',
  ' (black matte)', ' (black pvd)', ' (blackout)', ' (gunmetal)', ' (chrome)'
];

function stripFinishSuffix(title) {
  var t = title;
  var suffixes = [
    ' - Black Matte', ' - Black PVD', ' - Blackout Finish', ' - New Black Finish',
    ' - Gunmetal Finish', ' - Gunmetal', ' - Black Onyx Finish', ' - Black Onyx',
    ' - Chrome Finish', ' - Chrome', ' - Blackout',
    ' Black Matte', ' Black PVD', ' Blackout Finish', ' New Black Finish',
    ' Gunmetal Finish', ' Gunmetal', ' Black Onyx', ' Chrome Finish'
  ];
  for (var i = 0; i < suffixes.length; i++) {
    if (t.toLowerCase().indexOf(suffixes[i].toLowerCase()) !== -1) {
      var idx = t.toLowerCase().lastIndexOf(suffixes[i].toLowerCase());
      t = t.slice(0, idx).trim();
      break;
    }
  }
  return t;
}

function getFinishLabel(title) {
  var t = title.toLowerCase();
  if (t.indexOf('black pvd') !== -1) return 'Black PVD';
  if (t.indexOf('black matte') !== -1) return 'Black Matte';
  if (t.indexOf('blackout') !== -1) return 'Blackout';
  if (t.indexOf('new black') !== -1) return 'Black';
  if (t.indexOf('black onyx') !== -1) return 'Black Onyx';
  if (t.indexOf('gunmetal') !== -1) return 'Gunmetal';
  if (t.indexOf('chrome') !== -1) return 'Chrome';
  return 'Standard';
}

function getGroupKey(title) {
  var t = title.toLowerCase().trim();
  for (var i = 0; i < FINISH_SUFFIXES.length; i++) {
    if (t.indexOf(FINISH_SUFFIXES[i]) !== -1) t = t.replace(FINISH_SUFFIXES[i], '').trim();
  }
  t = t.replace(/dynamic gold mid tour issue/, 'dynamic gold tour issue mid');
  t = t.replace(/[-–\s]+$/, '').trim();
  return t;
}

function buildQuizProductUrl(handle, rank) {
  var profile = window._currentProfileKey || window._currentQuizProfile || 'unknown';
  var sessionId = '';
  try { sessionId = getIronQuizSessionId ? getIronQuizSessionId() : ''; } catch(e) {}

  return 'https://www.alphagolfclubs.com/products/' + handle +
    '?utm_source=iron_shaft_quiz' +
    '&utm_medium=quiz_recommendation' +
    '&utm_campaign=iron_shaft_finder' +
    '&utm_content=' + encodeURIComponent(profile + '_rank_' + rank) +
    '&utm_term=' + encodeURIComponent(handle) +
    '&quiz_session_id=' + encodeURIComponent(sessionId || '');
}

function renderProducts(products) {
  if (!products || products.length === 0) {
    return '<div class="recs-error">Could not load recommendations right now. <a href="https://www.alphagolfclubs.com/collections/iron-shafts" style="color:#1a6e3c;font-weight:600">Browse all iron shafts →</a></div>';
  }

  var groups = {};
  var order = [];

  products.forEach(function(p) {
    var key = getGroupKey(p.title);
    if (!groups[key]) { groups[key] = []; order.push(key); }
    groups[key].push(p);
  });

  var topGroups = order.slice(0, 5).map(function(k) { return groups[k]; });

  return topGroups.map(function(group, gi) {
    group.sort(function(a, b) {
      var aImg = a.featuredImage ? 1 : 0;
      var bImg = b.featuredImage ? 1 : 0;
      if (bImg !== aImg) return bImg - aImg;
      return a.handle.length - b.handle.length;
    });

    var p = group[0];
    var price = parseFloat(p.priceRange.minVariantPrice.amount);
    var url = buildQuizProductUrl(p.handle, gi + 1);

    var imgHtml = p.featuredImage
      ? '<img class="r-rec__img" src="' + p.featuredImage.url + '" alt="' + (p.featuredImage.altText || p.title) + '" loading="lazy" id="rimg-' + gi + '">'
      : '<div class="r-rec__img-placeholder" id="rimg-' + gi + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="18" r="3"/><line x1="12" y1="15" x2="12" y2="3"/><path d="M12 3l6 4-6 4"/></svg></div>';

    var displayTitle = group.length > 1 ? stripFinishSuffix(p.title) : p.title;

    var finishHtml = '';
    if (group.length > 1) {
      finishHtml = '<div class="r-rec__finishes">';
      group.forEach(function(fp, fi) {
        var label = getFinishLabel(fp.title);
        var fpUrl = buildQuizProductUrl(fp.handle, gi + 1);
        var imgSrc = fp.featuredImage ? fp.featuredImage.url : '';
        var imgAlt = fp.featuredImage ? (fp.featuredImage.altText || '').replace(/'/g, '') : '';
        var active = (fi === 0) ? ' r-finish-btn--active' : '';
        finishHtml += '<button class="r-finish-btn' + active + '" onclick="selectFinish(event,' + gi + ',\'' + fpUrl + '\',\'' + imgSrc + '\',\'' + imgAlt + '\')">' + label + '</button>';
      });
      finishHtml += '</div>';
    }

    return '<div class="r-rec-wrap">' +
      '<a class="r-rec" href="' + url + '" id="rlink-' + gi + '" target="_blank" rel="noopener">' +
        imgHtml +
        '<div class="r-rec__info">' +
          '<div class="r-rec__name">' + displayTitle + '</div>' +
          '<div class="r-rec__meta">From $' + price.toFixed(0) + '</div>' +
        '</div>' +
        '<svg width="16" height="16" class="r-rec__arrow"><use href="#ic-ar"/></svg>' +
      '</a>' +
      finishHtml +
    '</div>';
  }).join('');
}

function selectFinish(e, gi, url, imgSrc, imgAlt) {
  e.preventDefault();
  var link = document.getElementById('rlink-' + gi);
  if (link) link.href = url;
  var img = document.getElementById('rimg-' + gi);
  if (img && imgSrc) { img.src = imgSrc; if (imgAlt) img.alt = imgAlt; }
  var wrap = e.target.closest('.r-rec__finishes');
  if (wrap) {
    wrap.querySelectorAll('.r-finish-btn').forEach(function(b){ b.classList.remove('r-finish-btn--active'); });
    e.target.classList.add('r-finish-btn--active');
  }
}

/* ─────────────────────────────────────────────
   FLEX RECOMMENDATION ENGINE — identical to G4L
─────────────────────────────────────────────── */
function getFlexRecommendation(profile) {
  var sp = ans[0];
  var tm = ans[1];
  var cons = ans[4];
  var hc = ans[8];
  var senior = (ans[11] === 'yes');
  var mat = profile.material;
  var rec = '';
  var why = '';

  if (mat === 'graphite') {
    if (sp === 'slow' || senior) {
      rec = 'Senior (A) flex';
      why = 'Your swing speed and profile are in the Senior flex range. Senior flex graphite loads and releases more actively, maximizing energy transfer for slower swing speeds.';
    } else if (sp === 'mod') {
      rec = (cons === 'inconsistent' || cons === 'average') ? 'Regular (R) flex' : 'Regular or Regular+ flex';
      why = 'Your speed is in the Regular graphite range. Regular gives enough help through the hitting zone without demanding perfect timing.';
    } else if (sp === 'modfast') {
      rec = (tm === 'aggressive') ? 'Stiff (S) flex' : 'Regular+ or Stiff (S) flex';
      why = 'You sit near the Regular/Stiff graphite border. Tempo decides whether to start softer or firmer.';
    } else {
      rec = 'Stiff (S) flex';
      why = 'Your speed is in the upper graphite range. Stiff keeps the shaft from over-loading and helps keep ball flight consistent.';
    }
  } else {
    var isAggressive = (tm === 'aggressive');
    var isConsistent = (cons === 'elite' || cons === 'solid');
    var isLowHc = (hc === 'scratch' || hc === 'low');

    if (sp === 'slow' || senior) {
      rec = 'Regular (R) flex';
      why = 'Regular steel is the right flex for your speed. Stiff steel will likely feel too demanding.';
    } else if (sp === 'mod') {
      rec = isAggressive ? 'Regular+ or Stiff (S) flex' : 'Regular (R) flex';
      why = 'Your speed is moderate, so tempo decides whether Regular or a firmer Regular/Stiff profile fits best.';
    } else if (sp === 'modfast') {
      rec = isAggressive ? 'Stiff (S) flex' : 'Regular+ or Stiff (S) flex';
      why = 'You sit around the Regular/Stiff border. Aggressive tempo moves you toward Stiff.';
    } else if (sp === 'fast') {
      rec = (isAggressive && isLowHc && isConsistent) ? 'Stiff+ or X-Stiff (X) flex' : 'Stiff (S) to X-Stiff (X) flex';
      why = 'Your speed calls for a firmer steel profile. Project X Rifle: 5.0 = Regular, 5.5 = Firm/Regular+, 6.0 = Stiff, 6.5 = X-Stiff, 7.0 = Tour X/TX.';
    } else {
      rec = 'X-Stiff (X) or Tour X/TX flex';
      why = 'Your speed puts you in X-Stiff territory. TX is best reserved for very consistent high-speed ball strikers.';
    }
  }

  return { rec: rec, why: why };
}

/* ─────────────────────────────────────────────
   PROFILE LOGIC — identical to G4L, Alpha Golf URLs
─────────────────────────────────────────────── */
function getProfile() {
  var sp     = ans[0];
  var tm     = ans[1];
  var fl     = ans[2];
  var cons   = ans[4];
  var pn     = ans[5];
  var gl     = ans[6];
  var curr   = ans[7];
  var hc     = ans[8];
  var senior = (ans[11] === 'yes');

  if (senior && sp !== 'slow') sp = (sp === 'mod') ? 'slow' : sp;

  var isSlowMod = (sp === 'slow' || sp === 'mod');
  var isFast = (sp === 'fast' || sp === 'vfast');
  var isVFast = (sp === 'vfast');
  var isAggressive = (tm === 'aggressive');
  var isSmooth = (tm === 'smooth');
  var lowBall = (fl === 'low');
  var highBall = (fl === 'balloon');
  var inconsistent = (cons === 'average' || cons === 'inconsistent');
  var isLowHc = (hc === 'scratch' || hc === 'low');
  var isBeginner = (hc === 'high' || hc === 'casual');
  var needsForgiveness = (inconsistent || hc === 'high' || hc === 'casual');
  var wantsComposite = (pn === 'pain' && !isSlowMod) ||
                       (gl === 'feel' && (sp === 'mod' || sp === 'modfast') && pn === 'no') ||
                       (curr === 'composite' && gl !== 'control');

  var BASE = 'https://www.alphagolfclubs.com/collections/iron-shafts';

  if (senior || sp === 'slow') {
    if (pn === 'pain') {
      return { t:'Vibration-damping graphite — senior', s:'Joint pain with a slower swing speed. Lightweight graphite built for vibration reduction is the priority.', specs:[{l:'Material',v:'Graphite or composite'},{l:'Weight',v:'55–80g'},{l:'Launch',v:'Mid-High'},{l:'Tip',v:'Mid-Soft'},{l:'Torque',v:'3.2°–5.0°'},{l:'Best for',v:'Senior speed, joint protection'}], w:'Lightweight graphite and composite shafts with vibration-damping construction are built to protect joints while helping slower swing speeds create enough launch and carry.', r:'compositeLight', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
    }
    if (gl === 'consistency' || cons === 'inconsistent') {
      return { t:'Lightweight graphite — consistency', s:'Your senior swing profile with a consistency focus points to a predictable lightweight shaft that narrows shot dispersion.', specs:[{l:'Material',v:'Graphite or lightweight steel'},{l:'Weight',v:'55–95g'},{l:'Launch',v:'Mid-High to High'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.5°–4.8°'},{l:'Best for',v:'Senior speed, consistency focus'}], w:'A predictable lightweight shaft gives you enough resistance to feel the shaft load while still helping you create speed.', r:'graphiteMid', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'mixed_light' };
    }
    if (lowBall || gl === 'height') {
      return { t:'Lightweight graphite — high launch', s:'Your swing profile calls for maximum launch assistance. A light, high-launching graphite shaft is the direct answer.', specs:[{l:'Material',v:'Graphite'},{l:'Weight',v:'50–75g'},{l:'Launch',v:'High'},{l:'Tip',v:'Soft'},{l:'Torque',v:'4.0°–5.5°'},{l:'Best for',v:'Slower speed, low ball flight'}], w:'A lightweight graphite shaft with a soft tip produces a high, active ball flight that lands steeply.', r:'graphiteHigh', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
    }
    if (isBeginner) {
      return { t:'Lightweight graphite — beginner friendly', s:'High-launch graphite built to make the game easier. Maximum forgiveness and carry distance.', specs:[{l:'Material',v:'Graphite'},{l:'Weight',v:'50–75g'},{l:'Launch',v:'High'},{l:'Tip',v:'Soft'},{l:'Torque',v:'4.0°–5.5°'},{l:'Best for',v:'Beginners, high handicaps, casual players'}], w:'A high-launch lightweight graphite helps you get the ball airborne consistently and carry further with the same effort.', r:'graphiteHigh', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
    }
    return { t:'Lightweight graphite', s:'Your swing speed calls for a shaft that works with you — lighter weight, more speed, less effort.', specs:[{l:'Material',v:'Graphite'},{l:'Weight',v:'55–75g'},{l:'Launch',v:'Mid-High'},{l:'Tip',v:'Soft-Mid'},{l:'Torque',v:'3.5°–5.0°'},{l:'Best for',v:'Slower swing speeds'}], w:'Lighter shafts produce more clubhead speed for the same effort.', r:'graphiteHigh', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
  }

  if (pn === 'pain' && isFast) {
    return { t:'Steel-fiber composite — heavier', s:'Joint pain with a faster swing. You need vibration protection without sacrificing the stability your speed requires.', specs:[{l:'Material',v:'Steel-fiber composite'},{l:'Weight',v:'90–110g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid-firm'},{l:'Torque',v:'2.0°–3.0°'},{l:'Best for',v:'Fast swing, joint protection'}], w:'SteelFiber, Recoil DART, MCI, Mitsubishi OT, and MMT all compete here.', r:'compositeMid', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
  }

  if (pn === 'pain') {
    return { t:'Steel-fiber composite', s:'Joint pain is the deciding factor. Steel-fiber composite gives you steel-like feel at lighter weight with less vibration.', specs:[{l:'Material',v:'Steel-fiber composite'},{l:'Weight',v:'75–95g'},{l:'Launch',v:lowBall?'Mid-High':'Mid'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.5°–3.5°'},{l:'Best for',v:'Joint protection, steel feel'}], w:'Steel-fiber composite shafts are built for players who need to protect their joints without giving up precision feedback.', r:'compositeMid', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
  }

  if (isVFast) {
    return { t: highBall || isAggressive ? 'Tour-weight steel — low launch, very firm' : 'Tour-weight steel', s: highBall ? 'You are generating too much shaft load. Heavy, firm-tipped, low-launch steel is the prescription.' : 'Your swing speed demands a heavy, stable shaft. Lighter options will feel unstable.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'120g–132g'},{l:'Launch',v:highBall?'Low / Low spin':'Low-Mid'},{l:'Tip',v:'Firm'},{l:'Torque',v:'1.5°–2.2°'},{l:'Best for',v:'High swing speeds'}], w:'Tour-weight steel prevents the unwanted flex that lighter shafts produce under a fast swing.', r:'tourSteel', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
  }

  if (sp === 'fast') {
    if (gl === 'feel' && isLowHc && !highBall) {
      return { t:'Steel-fiber composite — tour feel, lighter weight', s:'Fast swing, serious player, wants feel. Steel-fiber composite delivers both.', specs:[{l:'Material',v:'Steel-fiber composite'},{l:'Weight',v:'90–110g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid-Firm'},{l:'Torque',v:'2.0°–2.8°'},{l:'Best for',v:'Fast swings, feel-focused players'}], w:'SteelFiber, MCI, OT, Recoil DART, and MMT are all considered here.', r:'compositeMid', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
    }
    if (lowBall || gl === 'height') {
      return { t:'Mid-weight steel — higher launch', s:'Fast swing with a low ball flight. A softer tip gets the ball up faster.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'100g–115g'},{l:'Launch',v:'Mid-High'},{l:'Tip',v:'Soft-Mid'},{l:'Torque',v:'2.2°–3.0°'},{l:'Best for',v:'Fast swings, low ball flight'}], w:'A softer tip releases more actively through impact, adding launch without excess spin.', r:'midDistance', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
    }
    if (highBall || isAggressive) {
      return { t:'Mid-weight steel — firm tip, reduced spin', s:'Fast swing but irons ballooning or loading hard. A firmer-tip mid-weight steel brings trajectory down.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'110g–122g'},{l:'Launch',v:'Mid-Low'},{l:'Tip',v:'Firm'},{l:'Torque',v:'1.7°–2.3°'},{l:'Best for',v:'Fast swings, high ball flight'}], w:'When irons balloon at fast swing speeds, the shaft is often over-flexing at impact.', r:'heavyControl', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
    }
    return { t:'Mid-weight steel — all-round performance', s:'Fast swing speed in the standard mid-weight range. The most proven iron shaft category.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'105g–115g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid-Firm'},{l:'Torque',v:'1.8°–2.4°'},{l:'Best for',v:'Fast swing speeds'}], w:'Mid-weight steel gives you a balance of control, feel, and distance.', r:'midControl', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
  }

  if (sp === 'modfast') {
    if (wantsComposite || (gl === 'feel' && curr === 'composite')) {
      return { t:'Steel-fiber composite — balanced feel', s:'Your speed is the sweet spot for steel-fiber composite — stable enough for consistent striking, light enough to benefit from the weight savings.', specs:[{l:'Material',v:'Steel-fiber composite'},{l:'Weight',v:'80–95g'},{l:'Launch',v:lowBall?'Mid-High':'Mid'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.5°–3.2°'},{l:'Best for',v:'Feel-focused mid-speed players'}], w:'Steel-fiber composite in the 80–95g range suits your swing speed well.', r:'compositeMid', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
    }
    if (highBall) {
      return { t:'Mid-weight steel — lower spin, firmer tip', s:'Irons going too high at your swing speed. A firmer tip section reduces the ballooning.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'105g–120g'},{l:'Launch',v:'Mid-Low'},{l:'Tip',v:'Firm-Mid'},{l:'Torque',v:'1.8°–2.4°'},{l:'Best for',v:'Mid-fast swings, high ball flight'}], w:'A firmer tip like Project X, C-Taper Lite, C-Taper, or Modus3 Tour 120 resists over-flexing.', r:'heavyControl', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
    }
    if (lowBall || gl === 'height') {
      return { t:'Mid-weight steel — higher launch', s:'Your speed can handle steel but your ball flight needs more height. A softer tip is the direct fix.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'95g–108g'},{l:'Launch',v:'Mid-High'},{l:'Tip',v:'Soft-Mid'},{l:'Torque',v:'2.2°–3.0°'},{l:'Best for',v:'Mid-speed players needing more height'}], w:'A softer tip loads and releases more actively through impact, launching the ball higher.', r:'midDistance', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
    }
    if (gl === 'distance' && (isSmooth || needsForgiveness)) {
      return { t:'Mid-weight composite — speed and distance', s:'Your tempo and distance goal both point to a composite shaft that extracts more speed.', specs:[{l:'Material',v:'Composite / steel-fiber'},{l:'Weight',v:'75–90g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.5°–3.5°'},{l:'Best for',v:'Mid-speed, distance-focused players'}], w:'Recoil DART, SteelFiber, MCI, Fujikura Pro, and KBS Max now compete better against MMT in this profile.', r:'compositeLight', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'graphite' };
    }
    if (needsForgiveness || gl === 'consistency') {
      return { t:'Mid-weight steel — forgiving profile', s:'A mid-weight steel with a slightly softer tip is more forgiving on off-center strikes.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'95g–108g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid-Soft'},{l:'Torque',v:'2.0°–2.8°'},{l:'Best for',v:'Mid-speed, consistency-focused players'}], w:'KBS Tour Lite and lighter high-launch steel options get more visibility here.', r:'midDistance', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
    }
    return { t:'Mid-weight steel — versatile', s:'Your swing profile fits the most common iron shaft category.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'95g–110g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.0°–2.6°'},{l:'Best for',v:'All-round mid-speed players'}], w:'Mid-weight steel in the correct flex is the most proven iron shaft category.', r:'midControl', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
  }

  if (sp === 'mod') {
    if (gl === 'distance' || isSmooth) {
      if (curr === 'toursteel' || curr === 'midsteel') {
        return { t:'Lightweight steel', s:'You are gaming a heavier shaft than your swing speed requires. Moving to lightweight steel will add distance.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'70g–95g'},{l:'Launch',v:lowBall?'High':'Mid-High'},{l:'Tip',v:'Soft-Mid'},{l:'Torque',v:'2.3°–3.5°'},{l:'Best for',v:'Moderate speed, distance-seeking'}], w:'KBS Tour Lite, Elevate, XP, Zelos, KBS Max Graphite, and KBS Max 80-style options can all fit this profile.', r:'lightSteel', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'mixed_light' };
      }
      return { t:'Lightweight graphite or composite', s:'A lighter shaft gets more out of your swing speed. Graphite or composite is the right direction for distance-focused players at your speed.', specs:[{l:'Material',v:'Graphite or composite'},{l:'Weight',v:'65–90g'},{l:'Launch',v:'Mid-High'},{l:'Tip',v:'Mid-Soft'},{l:'Torque',v:'3.0°–4.5°'},{l:'Best for',v:'Moderate speed, distance-focused'}], w:'Recoil DART, SteelFiber, MCI, Fujikura Pro, KBS Max Graphite, and Vista Pro get more competition here.', r:'compositeLight', c:'iron-shafts', collections:['iron-shafts'], material:'graphite', materialMode:'mixed_light' };
    }
    if (lowBall || gl === 'height') {
      return { t:'Lightweight steel — higher launch', s:'Moderate swing speed with a low ball flight. Lightweight steel with a softer tip gets the ball up.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'72g–95g'},{l:'Launch',v:'High'},{l:'Tip',v:'Soft'},{l:'Torque',v:'2.4°–3.8°'},{l:'Best for',v:'Moderate speed, low ball flight'}], w:'A lighter shaft with a soft tip produces a higher, more active ball flight.', r:'lightSteel', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'mixed_light' };
    }
    if (gl === 'feel' && !needsForgiveness) {
      return { t:'Mid-weight steel', s:'Moderate swing speed, focused on feel. Standard mid-weight steel is the classic answer.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'95g–108g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.0°–2.8°'},{l:'Best for',v:'Moderate speed, feel-focused players'}], w:'Mid-weight steel is the most feel-informative material in iron shafts.', r:'midControl', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
    }
    if (needsForgiveness || gl === 'consistency') {
      return { t:'Lightweight steel — forgiving', s:'Moderate swing speed, forgiveness and consistency are the goals.', specs:[{l:'Material',v:'Steel or lightweight graphite'},{l:'Weight',v:'72g–95g'},{l:'Launch',v:'Mid-High'},{l:'Tip',v:'Mid-Soft'},{l:'Torque',v:'2.5°–3.5°'},{l:'Best for',v:'Moderate speed, consistency-focused'}], w:'A lightweight steel or graphite shaft with a softer tip is more forgiving on off-center strikes.', r:'lightSteel', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'mixed_light' };
    }
    return { t:'Lightweight to mid-weight steel', s:'Your speed is in the transition zone between lightweight and mid-weight. Either works — it comes down to feel preference.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'85g–105g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.2°–3.0°'},{l:'Best for',v:'Moderate swing speeds'}], w:'At your speed, both lightweight and mid-weight steel work well.', r:'midDistance', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
  }

  return { t:'Mid-weight steel — all-round', s:'Your answers point to the most widely played iron shaft category.', specs:[{l:'Material',v:'Steel'},{l:'Weight',v:'95g–115g'},{l:'Launch',v:'Mid'},{l:'Tip',v:'Mid'},{l:'Torque',v:'2.0°–2.8°'},{l:'Best for',v:'All-round players'}], w:'Mid-weight steel in the right flex is the benchmark iron shaft category.', r:'midControl', c:'iron-shafts', collections:['iron-shafts'], material:'steel', materialMode:'steel' };
}

/* ─────────────────────────────────────────────
   QUIZ NAVIGATION — identical to G4L
─────────────────────────────────────────────── */
function pick(btn) {
  var q = parseInt(btn.getAttribute('data-q'), 10);
  var v = btn.getAttribute('data-v');
  ans[q] = v;

  btn.parentNode.querySelectorAll('.ob').forEach(function(b) { b.classList.remove('sel'); });
  btn.classList.add('sel');

  var n = document.getElementById('n' + q);
  if (n) n.classList.add('rdy');

}

function go(i) {
  if (!ans[i]) return;
  document.getElementById('s' + i).classList.remove('active');
  var nx = i + 1;
  if (nx < TOTAL_Q) {
    document.getElementById('s' + nx).classList.add('active');
    document.getElementById('pf').style.width = Math.round((nx / TOTAL_Q) * 100) + '%';
    document.getElementById('plabel').textContent = (nx + 1) + ' of ' + TOTAL_Q;
  }
}

function back(i) {
  document.getElementById('s' + i).classList.remove('active');
  document.getElementById('s' + (i - 1)).classList.add('active');
  document.getElementById('pf').style.width = Math.round(((i - 1) / TOTAL_Q) * 100) + '%';
  document.getElementById('plabel').textContent = i + ' of ' + TOTAL_Q;
}

function showResult() {
  if (!ans[11]) return;

  document.getElementById('pf').style.width = '100%';
  document.getElementById('plabel').textContent = 'Complete';

  for (var i = 0; i < TOTAL_Q; i++) {
    var s = document.getElementById('s' + i);
    if (s) s.classList.remove('active');
  }

  var p = getProfile();
  var flex = getFlexRecommendation(p);
  window._currentQuizProfile = p.r;



  document.getElementById('rtitle').textContent = p.t;
  document.getElementById('rsub').textContent = p.s;
  document.getElementById('rspecs').innerHTML = p.specs.map(function(x) {
    return '<div class="r-spec"><div class="r-spec__label">' + x.l + '</div><div class="r-spec__val">' + x.v + '</div></div>';
  }).join('');
  document.getElementById('rwhy').textContent = p.w;
  document.getElementById('rflex').textContent = flex.rec;
  document.getElementById('rflexwhy').textContent = flex.why;

  var shopUrl = 'https://www.alphagolfclubs.com/collections/iron-shafts';
  document.getElementById('shopBtn').href = shopUrl;

  var tipNote = '';
  if (ans[9] === '355') tipNote = 'Order in .355" Taper Tip';
  if (ans[9] === '370') tipNote = 'Order in .370" Parallel Tip';
  var tipEl = document.getElementById('rtipnote');
  if (tipEl) tipEl.textContent = tipNote;
  if (tipEl) tipEl.style.display = tipNote ? 'block' : 'none';

  document.getElementById('rpanel').classList.add('active');

  fetchAndScore(p, p.collections || p.c, function(err, products) {
    document.getElementById('rrecs').innerHTML = (err || !products)
      ? '<div class="recs-error">Could not load live recommendations. <a href="' + shopUrl + '" style="color:#1a6e3c;font-weight:600">Browse the collection →</a></div>'
      : renderProducts(products);

    if (products && products.length) {
      var recTitles = [];
      var recHandles = [];

      document.getElementById('rrecs').querySelectorAll('.r-rec').forEach(function(el, idx) {
        var nameEl = el.querySelector('.r-rec__name');
        var title = nameEl ? nameEl.textContent.trim() : '';
        var href = el.href || '';
        var handle = href.split('/products/')[1];
        if (title) recTitles.push(title);
        if (handle) {
          handle = handle.split('?')[0];
          if (recHandles.indexOf(handle) === -1) recHandles.push(handle);
        }
      });


    }
  });
}

function resetQ() {
  ans = {};
  document.getElementById('rpanel').classList.remove('active');
  document.getElementById('rrecs').innerHTML = '<div class="recs-loading"><div class="spinner"></div>Finding your best matches...</div>';

  for (var i = 0; i < TOTAL_Q; i++) {
    var s = document.getElementById('s' + i);
    if (s) {
      s.classList.remove('active');
      s.querySelectorAll('.ob').forEach(function(b){ b.classList.remove('sel'); });
    }
    var n = document.getElementById('n' + i);
    if (n && i < TOTAL_Q - 1) n.classList.remove('rdy');
  }

  document.getElementById('s0').classList.add('active');
  document.getElementById('pf').style.width = '0%';
  document.getElementById('plabel').textContent = '1 of ' + TOTAL_Q;

  var hero = document.querySelector('.quiz-hero');
  if (hero) hero.scrollIntoView({ behavior: 'smooth' });
  else window.scrollTo({ top: 0, behavior: 'smooth' });
}